import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'change-impacts',
    description: 'Manage, store, and track change impacts for an OCM project.',
    icon: 'tools',
    name: 'Change Impacts',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
